import React, { FC } from 'react'

import { IconProps } from '../Icon'
import { ActionButtonProps } from '../ActionButton'
import { DeclarationTableProps } from '../DeclarationTable'

import * as SC from './styled'

export type DeclarationBlockProps = {
  className?: string
  icon: IconProps
  title: string
  actions?: ActionButtonProps[]
  declarationTable: DeclarationTableProps
}

const DeclarationBlock: FC<DeclarationBlockProps> = (props) => {
  const { className, icon, title, actions, declarationTable } = props

  return (
    <SC.Container className={className}>
      <SC.Head>
        <SC.Left>
          <SC.StyledIcon {...icon} />
          <SC.Title>{title}</SC.Title>
        </SC.Left>
        {actions && (
          <SC.Actions>
            {actions.map((action, index) => (
              <SC.Action key={index} {...action} />
            ))}
          </SC.Actions>
        )}
      </SC.Head>
      <SC.DeclarationTable {...declarationTable} />
      {actions && (
        <SC.Actions $isMobile>
          {actions.map((action, index) => (
            <SC.Action key={index} {...action} />
          ))}
        </SC.Actions>
      )}
    </SC.Container>
  )
}

export default DeclarationBlock
